import { GallerySearchPageComponent } from './gallery-search-page/gallery-search-page.component';
import { GalleryCategoryPageComponent } from './gallery-category-page/gallery-category-page.component';
import { GalleryCollectionPageComponent } from './gallery-collection-page/gallery-collection-page.component';
import { GalleryComponent } from './gallery.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GalleryItemPageComponent } from './gallery-item-page/gallery-item-page.component';

const routes: Routes = [
  {
    path: '',
    component: GalleryComponent
  },
  {
    path: 'collection/:collection',
    component: GalleryCollectionPageComponent,
    data: {
      title: 'Collection :collection',
      description: `View our gallery collections for trees, shrubs, flowers, mulch, stone, and more.`,
      imageURL:
        'https://firebasestorage.googleapis.com/v0/b/russells-web.appspot.com/o/collections%2Fgallery-records%2FjMvB1Jza5o9aLzcT68Au%2Fthumb%40512_1597250995942_image.jpg?alt=media&token=38cb65b8-ff74-47e3-b9f5-20e389191377'
    }
  },
  {
    path: 'collection/:collection/category/:category',
    component: GalleryCategoryPageComponent,
    data: {
      title: 'Category :category',
      description: `View our gallery categories for trees, shrubs, flowers, mulch, stone, and more.`,
      imageURL:
        'https://firebasestorage.googleapis.com/v0/b/russells-web.appspot.com/o/collections%2Fgallery-records%2FjMvB1Jza5o9aLzcT68Au%2Fthumb%40512_1597250995942_image.jpg?alt=media&token=38cb65b8-ff74-47e3-b9f5-20e389191377'
    }
  },
  {
    path: 'item/:itemId',
    component: GalleryItemPageComponent,
    data: {
      title: 'View Gallery Item',
      description: `View our gallery categories for trees, shrubs, flowers, mulch, stone, and more.`,
      imageURL:
        'https://firebasestorage.googleapis.com/v0/b/russells-web.appspot.com/o/collections%2Fgallery-records%2FjMvB1Jza5o9aLzcT68Au%2Fthumb%40512_1597250995942_image.jpg?alt=media&token=38cb65b8-ff74-47e3-b9f5-20e389191377'
    }
  },
  {
    path: 'search',
    component: GallerySearchPageComponent,
    data: {
      title: 'Search Gallery',
      description: `Search our gallery for trees, shrubs, flowers and more.`,
      imageURL:
        'https://firebasestorage.googleapis.com/v0/b/russells-web.appspot.com/o/collections%2Fgallery-records%2FjMvB1Jza5o9aLzcT68Au%2Fthumb%40512_1597250995942_image.jpg?alt=media&token=38cb65b8-ff74-47e3-b9f5-20e389191377'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GalleryRoutingModule {}
